import React, { useEffect, useState } from 'react';
import { Grid } from 'semantic-ui-react';
import { getEstate } from '../../services/estate';
import { maskPhoneNumber } from '../../services/masks';
import { InsurersCodeEnum } from '../../enums/insurers-code.enum';
import { FieldLabel } from '../../styles';
import { Info } from '../Info';

interface Contact {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

interface Props {
  estateId?: string;
  visible: boolean;
  renderContact?: (contact: {
    name: string;
    email: string;
    phone: string;
  }) => React.ReactNode;
}

export const CreditasAnalysisResponsible = ({
  estateId,
  visible,
  renderContact
}: Props) => {
  const [contact, setContact] = useState<Contact>();
  const [status, setStatus] = useState<'loading' | 'loaded' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    setContact(undefined);
    setStatus('loading');
    if (!visible) return;
    if (!estateId) {
      setStatus('error');
      return;
    }

    getEstate(estateId)
      .then(estate => {
        if (cancelled) return;
        const config = estate.insurer_data?.find(
          data =>
            data.insurer?.code === InsurersCodeEnum.Creditas &&
            data.insurance_type === 'BOND_INSURANCE'
        );
        setContact({
          name: config?.responsible_name,
          email: config?.responsible_email,
          phone: config?.responsible_phone
        });
        setStatus('loaded');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [estateId, visible]);

  if (!visible) return null;
  const fallback =
    status === 'loading'
      ? 'Carregando...'
      : status === 'error'
      ? 'Indisponível'
      : 'Não informado';

  if (renderContact) {
    return (
      <>
        {renderContact({
          name: contact?.name || fallback,
          email: contact?.email || fallback,
          phone: contact?.phone ? maskPhoneNumber(contact.phone) : fallback
        })}
      </>
    );
  }

  return (
    <>
      <FieldLabel paddingTop>RESPONSÁVEL PELA ANÁLISE CREDITAS</FieldLabel>
      <Grid.Row>
        <Info name="Nome" value={contact?.name || fallback} width={8} />
        <Info name="E-mail" value={contact?.email || fallback} width={8} />
      </Grid.Row>
      <Grid.Row>
        <Info
          name="Telefone"
          value={contact?.phone ? maskPhoneNumber(contact.phone) : fallback}
          width={8}
        />
      </Grid.Row>
    </>
  );
};
